/**
 * This store is responsible for holding information about
 * images from different sources
 */
import AppDispatcher from '../dispatcher/app-dispatcher'
import assign from 'lodash/assign'

const EventEmitter = require('events').EventEmitter
const CHANGE_EVENT = 'change';

//A list of OpeImage's
var _imageList = {};

/**
 * Private function that adds an image to the _imageList object
 * @param image {OpeImage} - The uploaded image in an OpeImage format, see 'objects/opeimage'
 */
function _addImageToImageList(image) {
    // If the image is not already in the image list, add it.
    if (!(image.getId() in _imageList)) {
        _imageList[image.getId()] = image;
    }
}

function _removeImageById(id) {
    delete _imageList[id];
}

function _setServerData(id, data) {
    if (_imageList.hasOwnProperty(id)) {
        _imageList[id].setServerData(data);
    }
}

var ImageStore = assign({}, EventEmitter.prototype, {
    transationActive: false,

    startTransaction: function () {
        this.transationActive = true;
    },
    stopTransaction: function () {
        this.transationActive = false;
        this.emit(CHANGE_EVENT);
    },
    emitChange: function () {
        //console.log("Items changed", _items);
        if (!this.transationActive) {
            this.emit(CHANGE_EVENT);
        }
    },

    addChangeListener: function (callback) {
        this.addListener(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getData: function () {
        return _imageList;
    },
    getImageById: function (id) {
        return _imageList[id];
    },

    dispatcherIndex: AppDispatcher.register(function (payload) {
        var action = payload.action;
        switch (action.actionType) {
            case 'addImageToStore':
                _addImageToImageList(action.image);
                ImageStore.emitChange();
                break;
            case 'addImagesToStore':
                for (var i = 0; i < action.images.length; i++) {
                    _addImageToImageList(action.images[i]);
                }
                ImageStore.emitChange();
                break;
            case 'removeImageFromStore':
                _removeImageById(action.imageId);
                ImageStore.emitChange();
                break;
            case 'setServerData':
                _setServerData(action.imageId, action.data);
                ImageStore.emitChange();
                break;
        }

        return true;
    })
});

export default ImageStore;
